<template>
  <div>
    <div class="flex-center">
      <div class="text-center" style="width: 30%">
        <div>二寸证件照</div>
        <img :src="form.officialPhoto2" alt="" style="width: 200px;">
      </div>
      <div class="text-center contrast" style="width: 30%">
        <div>留底照片</div>
        <div v-if="form.contrastPhoto2">
          <el-image :src="form.contrastPhoto2" :preview-src-list="[form.contrastPhoto2]" style="width: 200px;height: 100%;"></el-image>
        </div>
        <el-upload class="inline-block" style="margin-top: 10px;" action="" :http-request="userUploadOSS" :show-file-list="false" accept=".png,.jpg">
          <el-button type="default" style="color: #1890FF;margin-left: 0px;">上传</el-button>
        </el-upload>
        <el-input class="none" type="text" v-model="form.contrastPhoto2" :maxlength="1024"></el-input>
        <!--        <img :src="form.contrastPhoto2" alt="" style="width: 200px;">-->
      </div>
      <div class="text-center" style="width: 30%">
        <div>人脸失败后上传的照片</div>
        <img :src="form.failPhoto2" alt="" style="width: 200px;">
        <el-button type="default" style="color: #1890FF;margin-left: 0px;margin-top: 10px;" @click="isContrast">置为留底</el-button>
      </div>
    </div>
    <div class="text-right" style="margin-top: 50px;">
      <el-button size="medium" @click="$emit('close', false)">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = await this.$HTTP.ApiFaceCertify.getInfo(this.row.logId)
        info.failPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.failPhoto, 'ID-photo')
        info.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'ID-photo')
        info.contrastPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.contrastPhoto, 'ID-photo')
        this.form = info
      }
    },
    async userUploadOSS (event) {
      try {
        // if (event.file.size < 1024 * 100) {
        //   throw new Error('仅支持JPG、PNG格式图片文件，且文件大小大于100KB')
        // }
        if (this.row.isSolve == 2) {
          let confirm = await this.$confirm('用户照片比对成功，确定要更换照片吗？', '提示', { type: 'warning' })
          if (confirm === 'confirm') {
            this.form.contrastPhoto = await this.$HTTP.ApiOss.uploadOSS(event.file, 'certificate', '.png,.jpg', 'ID-photo')
            this.form.contrastPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.form.contrastPhoto, 'ID-photo')
            let params = {
              examineeId: this.row.examineeId,
              contrastPhoto: this.form.contrastPhoto
            }
            await this.$HTTP.ApiFaceCertify.commitPhoto(params)
            this.$forceUpdate()
          }
        } else {
          this.form.contrastPhoto = await this.$HTTP.ApiOss.uploadOSS(event.file, 'certificate', '.png,.jpg', 'ID-photo')
          this.form.contrastPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.form.contrastPhoto, 'ID-photo')
          let params = {
            examineeId: this.row.examineeId,
            contrastPhoto: this.form.contrastPhoto
          }
          await this.$HTTP.ApiFaceCertify.commitPhoto(params)
          this.$forceUpdate()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async isContrast () {
      let params = {
        examineeId: this.row.examineeId,
        contrastPhoto: this.form.failPhoto
      }
      await this.$HTTP.ApiFaceCertify.commitPhoto(params)
      await this.initForm()
      this.$forceUpdate()
    }
  }
}
</script>
<style>
.contrast .el-image__inner {
  width: 100% !important;
}
</style>
